import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  OrderItemAction, 
  setIsFetching, 
  setPerformance, 
  setFetchFailed,
} from 'Components/OrderItem/Redux/actions';
import moment from 'moment';

export const fetchPerformance = (id: number) => {
  return async (dispatch: Dispatch<OrderItemAction>): Promise<void> => {
    const { isFetching, performance } = Store.getState().orderItem;

    if (!id || isFetching || (performance && performance.performanceID === Number(id))) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('PerformanceOverview', `ID=${ id }`);

      if (response.status === 200) {
        const newPerformance: Julius.Website.PerformanceOverviewViewModel = await response.json();
        newPerformance.date = moment(newPerformance.date).toDate();
        newPerformance.startSaleDate = moment(newPerformance.startSaleDate).toDate();
        dispatch(setPerformance(newPerformance));
      } else {
        dispatch(setFetchFailed());
      }

    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/OrderItem/Redux/thunks.tsx